import React, { useEffect, useState } from 'react';
import { getInsightActions } from '../../services/summaryService';
import { BsSend } from 'react-icons/bs';
import parse from 'html-react-parser';
import config from '../../configs/config';
import { HTMLformatter, HTMLremover } from '../../functions/commonFunctions';
import { getAnomalyList } from '../../services/anomalyService';

const InsightsActions = (props) => {
  const [insights, setInsights] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    async function getData() {
      try {
        setLoader(true);
        const desiredOrder = [
          '2024-12-01--*--net_sales-*-LATM-*-Brazil',
'2024-12-01--*--net_sales-*-America-*-Canada',
'2024-12-01--*--roi-*-America-**-QuantumSecure Chip-QS500-*-Security-*-Hardware Security Module-*-General-**-America-*-Canada-*-TechAlliance',
'2024-12-01--*--net_sales-*-EMEA-*-Spain',
'2024-12-01--*--revenue_after_discount_dollar-*-EMEA-*-Spain'
        ];
        

        const { data } = await getAnomalyList(0, 6, {
          rca_present: true,
          anomaly_id: desiredOrder
        });

        // Reorder the API response based on the desired anomaly_id order
        const sortedData = desiredOrder
          .map((id) => data.find((item) => item.anomaly_id === id))
          .filter(Boolean); // filter out any not-found entries just in case

        setInsights(sortedData);
        setLoader(false);
      } catch (err) {
        setLoader(false);
        console.log(err);
      }
    }
    getData();
  }, []);

  const submitQuery = (query, type, id) => {
    window.location =
      (config.prefix ? '/' + config.prefix_name : '') +
      '/chat?query=' +
      query.replaceAll('%', ' percentage') +
      '&type=' +
      type +
      '&id=' +
      id;
  };

  // Component - Placeholder
  const PlaceHolder = (key) => {
    return (
      <div className='d-flex' key={key}>
        <div className='flex-fill'>
          <p className='placeholder-glow mb-2'>
            <span
              className='placeholder col-12 insight-placeholder-card'
              style={{ borderRadius: '0.5rem' }}
            ></span>
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className='place-container'>
      <h5 className='mb-4'>Insights</h5>
      <div className='insights-actions'>
        {!loader &&
          insights.length > 0 &&
          insights.map((x, i) => {
            return (
              <div className='insight-card' key={i}>
                <div className={`insight-type ${x.anomaly_type}`}>
                  {x.anomaly_type}
                </div>
                <div className='insight'>
                  {parse(HTMLformatter(x.inference))}
                </div>
                <div
                  className='open-chat'
                  onClick={() =>
                    submitQuery(
                      'Explain why ' + HTMLremover(x.inference),
                      'alert',
                      x.anomaly_id
                    )
                  }
                >
                  Open in Chat <BsSend />
                </div>
              </div>
            );
          })}
        {!loader && insights.length === 0 && (
          <div className='no-data'>No Insights found</div>
        )}
        {loader && (
          <div className='loader'>
            {[...Array(5).keys()].map((x) => {
              return PlaceHolder(x);
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default InsightsActions;
